import * as React from "react";
import type { ReactElement } from "react";

import * as _ from "lodash";
import styled from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";
import type { IDropdownProps } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";

const SWReactCountryIconsStyled = styled(SWReactCountryIcons)`
    width: 18px;
    margin-left: -16px;
    margin-right: 8px;
`;

interface IDropdownContainerProps extends IDropdownProps<any> {
    showCountryFlag?: boolean;
    onSelect: (item) => void;
    initialSelection?: any;
}

export class DropdownContainer extends React.PureComponent<IDropdownContainerProps, any> {
    public static defaultProps = {
        initialSelection: {},
        buttonText: "Please Select",
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedIds: props.initialSelection,
            buttonText: DropdownContainer.getInitialSelectedText(props),
        };
    }

    public static getInitialSelectedText = (props) => {
        let selectedCountryId = parseInt(Object.keys(props.initialSelection)[0], 10);
        let selectedItem: any = _.find(props.children, { id: selectedCountryId });
        if (!selectedItem) {
            selectedItem = props.children[1];
            selectedCountryId = props.children[1].id;
        }
        if (!props.showCountryFlag) {
            return selectedItem.text;
        } else {
            return [
                <SWReactCountryIconsStyled
                    key={selectedCountryId}
                    countryCode={selectedCountryId}
                    size="sm"
                />,
                selectedItem.text,
            ];
        }
    };

    public onClick = (newItem) => {
        this.setState({
            selectedIds: { [newItem.id]: true },
            buttonText: this.getButtontext(newItem),
        });
        this.props.onSelect(newItem);
    };

    public getButtontext = (newItem) => {
        if (!this.props.showCountryFlag) {
            return newItem.children;
        } else {
            return [
                <SWReactCountryIconsStyled
                    key={newItem.id}
                    countryCode={newItem.id}
                    size="sm"
                />,

                newItem.children,
            ];
        }
    };

    public render() {
        // text in dropdown button is changing on item click -> change its children's prop
        const newChildren = [
            React.cloneElement(
                this.props.children[0] as ReactElement,
                { key: "dropdown-button" },
                this.state.buttonText,
            ),
            ...this.props.children.slice(1),
        ];
        return (
            <Dropdown
                selectedIds={this.state.selectedIds}
                onClick={this.onClick}
                {...this.props}
            >
                {newChildren}
            </Dropdown>
        );
    }
}
